export const companyInfo = {
  brandName: "WaBM",
  companyName: "Infokey Technology Pvt. Ltd.",
  productName: "WaBM by Infokey",
  contactEmail: "mail@wabm.in",
  tos: { lastUpdated: "Oct 21, 2026" },
  copyrightYear: new Date().getFullYear(),
  address: "New Delhi, India",
  website: "https://wabm.in",
};
